export default __webpack_public_path__ + "static/media/Aura-Egg__31.09c920c0.png";